module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copyright"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_vm._v("© 2005 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All writings by Helen Keller courtesy of the American Foundation"), _c('br'), _vm._v("for the Blind. Requests for permission for the use of these materials"), _c('br'), _vm._v("should be addressed in writing to the American Foundation for the"), _c('br'), _vm._v("Blind, 11 Penn Plaza, Suite 300, New York, NY 10001.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All photographs courtesy of the American Foundation for the Blind,"), _c('br'), _vm._v("Helen Keller Archives.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Book design by Charles B. Hames")]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Keller, Helen, 1880-1968.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("[Selections. 2005]")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Helen Keller : selected writings / edited by Kim E. Nielsen.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("p. cm. —(The history of disability series)")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("“Published in conjunction with the")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("American Foundation for the Blind.”")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("ISBN 0-8147-5829-0 (cloth : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("1. Keller, Helen, 1880-1968.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("2. Blind-deaf women—United States.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("I. Nielsen, Kim E. II. Title. III. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("HV1624.K4A25    2005")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("362.4′1′092-dc22       2004028974")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("New York University Press books are printed on acid-free paper,"), _c('br'), _vm._v("and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_vm._v("c 10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("p 10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440eb2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copyright.vue
// module id = 66
// module chunks = 0